import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useCreditNotesTable } from 'src/pages/orders/payments/creditNotes/useCreditNotesTable';

export const CreditNotesTablePage = () => {
  const [columns, tableSettings] = useCreditNotesTable();
  return (
    <>
      <PageHeader title={'Credit Notes'} subTitle={'Register and track credit notes for customer orders'} components={[...generateTablePageButtons(tableSettings)]} />
      <ContentCardsContainer>
        <ContentCard {...{ cardTypes: [CardType.noHeader], contentPadding: 0 }}>
          <CustomDataGrid columns={columns} tableSettings={tableSettings} />
        </ContentCard>
      </ContentCardsContainer>
      <Footer />
    </>
  );
};
export default CreditNotesTablePage;
